import React, { createContext, useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ORDERS_OPEN } from '../config/serviceStatus';
import ServiceClosedModal from './ServiceClosedModal';

const ServiceStatusContext = createContext(null);

export const useServiceRequest = () => {
  const context = useContext(ServiceStatusContext);
  if (!context) {
    throw new Error('useServiceRequest는 ServiceStatusProvider 내부에서만 사용할 수 있습니다.');
  }
  return context;
};

const ServiceStatusProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 세탁 신청 진입점에서 공통으로 호출합니다.
  // 접수 중이면 신청 폼으로 이동하고, 중단 상태면 안내 모달을 띄웁니다.
  const requestCleaning = useCallback(
    (navigateOptions) => {
      if (ORDERS_OPEN) {
        navigate('/cleaning-request-form', navigateOptions);
      } else {
        setIsModalOpen(true);
      }
    },
    [navigate]
  );

  const closeModal = useCallback(() => setIsModalOpen(false), []);

  return (
    <ServiceStatusContext.Provider value={{ ordersOpen: ORDERS_OPEN, requestCleaning }}>
      {children}
      <ServiceClosedModal isOpen={isModalOpen} onClose={closeModal} />
    </ServiceStatusContext.Provider>
  );
};

export default ServiceStatusProvider;
